import React, { Suspense, lazy } from 'react';
import './components/PreloadAssets';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
// Below-the-fold sections lazy-loaded to dramatically reduce initial JS/render cost on mobile
const TopReviews = lazy(() => import('./components/sections/TopReviews').then(m => ({
  default: m.TopReviews
})));
const Agitation = lazy(() => import('./components/sections/Agitation').then(m => ({
  default: m.Agitation
})));
const BeforeAfter = lazy(() => import('./components/sections/BeforeAfter').then(m => ({
  default: m.BeforeAfter
})));
const WhoFor = lazy(() => import('./components/sections/WhoFor').then(m => ({
  default: m.WhoFor
})));
const WhyDifferent = lazy(() => import('./components/sections/WhyDifferent').then(m => ({
  default: m.WhyDifferent
})));
const SixBooks = lazy(() => import('./components/sections/SixBooks').then(m => ({
  default: m.SixBooks
})));
const ContentPreview = lazy(() => import('./components/sections/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Offer = lazy(() => import('./components/sections/Offer').then(m => ({
  default: m.Offer
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Mission = lazy(() => import('./components/sections/Mission').then(m => ({
  default: m.Mission
})));
const SocialFeed = lazy(() => import('./components/sections/SocialFeed').then(m => ({
  default: m.SocialFeed
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
// Tiny placeholder that reserves vertical space to avoid layout shift while sections stream in
const SectionFallback = () => <div className="w-full h-64" aria-hidden="true" data-id="element-0" />;
export function App() {
  return <div className="w-full min-h-screen" data-id="element-1">
      <MetaPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <Suspense fallback={<SectionFallback data-id="element-5" />} data-id="element-4">
        <TopReviews data-id="element-6" />
        <Agitation data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <WhoFor data-id="element-9" />
        <WhyDifferent data-id="element-10" />
        <SixBooks data-id="element-11" />
        <ContentPreview data-id="element-12" />
        <Bonuses data-id="element-13" />
        <Offer data-id="element-14" />
        <Guarantee data-id="element-15" />
        <Mission data-id="element-16" />
        <SocialFeed data-id="element-17" />
        <FAQ data-id="element-18" />
        <FinalCTA data-id="element-19" />
        <Footer data-id="element-20" />
      </Suspense>
    </div>;
}